import heatingType, { HeatingTypeStepContext } from '~/steps/heating/type';
import heatingUsage, { HeatingUsageStepContext } from '~/steps/heating/usage';
import heatingDistribution, {
  HeatingDistributionStepContext,
} from '~/steps/heating/distribution';
import heatingConstructionYear, {
  HeatingConstructionYearStepContext,
} from '~/steps/heating/construction-year';
import heatingBuildingType, {
  HeatingBuildingTypeStepContext,
} from '~/steps/heating/building-type';
import heatingInterest, {
  HeatingInterestStepContext,
} from '~/steps/heating/heating-interest';

// Add the imported StepDefinition from the steps in the order
// the steps should be shown in the assistant.
const steps = [
  heatingType,
  heatingUsage,
  heatingDistribution,
  heatingConstructionYear,
  heatingBuildingType,
  heatingInterest,
];

// Add the imported context interface for the steps
export interface HeatingAssistantContext {
  heatingType: HeatingTypeStepContext;
  heatingUsage: HeatingUsageStepContext;
  heatingDistribution: HeatingDistributionStepContext;
  heatingConstructionYear: HeatingConstructionYearStepContext;
  heatingBuildingType: HeatingBuildingTypeStepContext;
  heatingInterest: HeatingInterestStepContext;
}

export default steps;
